import { Grid, Tab, Tabs, Toolbar } from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { IndicatorCategory } from '~/services/Http';

import { IndicatorCategoryTab } from '../../../../models';
import { CategoryIconFormatter } from '../../../CategoryIconFormatter';

import { useSxStyles } from './useStyles';

export interface Props {
  selectedCategory: IndicatorCategoryTab;
  handleCategoryChange: (
    event: React.ChangeEvent<{}>,
    value: IndicatorCategoryTab,
  ) => void;
  indicatorList: string[];
}

export const NavigationBar: React.FC<Props> = ({
  selectedCategory,
  handleCategoryChange,
  indicatorList,
}) => {
  const sxStyles = useSxStyles();
  const { t } = useTranslation();

  return (
    <Toolbar sx={sxStyles.actionBar}>
      <Grid container justifyContent="space-between">
        <Grid item>
          <Tabs
            value={selectedCategory}
            onChange={handleCategoryChange}
            textColor="primary"
            sx={{
              '&': sxStyles.tabs,
              '&.MuiTabs-flexContainer': {
                ...sxStyles.flexContainer,
                ...sxStyles.tabs,
              },
            }}
            data-cy="tabs"
            TabIndicatorProps={{ style: { background: '#ffc000' } }}
          >
            <Tab sx={sxStyles.tab} label={t('all')} data-cy="all" />
            {Object.keys(IndicatorCategory)
              .filter((category) => {
                if (category === IndicatorCategory.CUSTOM) {
                  return indicatorList.includes(IndicatorCategory.CUSTOM);
                }
                return true;
              })
              .map((category) => {
                return (
                  <Tab
                    key={category}
                    sx={sxStyles.tab}
                    icon={
                      <CategoryIconFormatter
                        category={category as IndicatorCategory}
                      />
                    }
                    data-cy={category}
                  />
                );
              })}
          </Tabs>
        </Grid>
      </Grid>
    </Toolbar>
  );
};
